
    <h2 mat-dialog-title style="color:#424242;">QA Review Results</h2>
    <mat-dialog-content style="background:#ffffff; color:#424242;">
      <p *ngIf="!data.findings.length" style="color:#2e7d32; font-weight:500; margin-top:0;">
        No findings &mdash; this file passed every QA check.
      </p>
      <p *ngIf="data.findings.length" style="color:#c62828; font-weight:500; margin-top:0;">
        {{ data.findings.length }} of the checks below did not match.
      </p>

      <table style="width:100%; border-collapse:collapse; font-size:0.9em; color:#424242;">
        <thead>
          <tr style="text-align:left; border-bottom:2px solid #d0d0d0;">
            <th style="padding:6px 8px;">Check</th>
            <th style="padding:6px 8px;">RaterHelper</th>
            <th style="padding:6px 8px;">Ekotrope</th>
            <th style="padding:6px 8px;">Result</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of data.checks"
              [ngStyle]="{ 'background': c.status === 'mismatch' ? '#fdecea' : '#ffffff' }"
              style="border-bottom:1px solid #eeeeee;">
            <td style="padding:6px 8px;">{{ c.check }}</td>
            <td style="padding:6px 8px;">{{ c.rh }}</td>
            <td style="padding:6px 8px;">{{ c.eko }}</td>
            <td style="padding:6px 8px; font-weight:500;"
                [ngStyle]="{ 'color': c.status === 'mismatch' ? '#c62828' : (c.status === 'match' ? '#2e7d32' : '#757575') }">
              <ng-container [ngSwitch]="c.status">
                <span *ngSwitchCase="'mismatch'">Mismatch</span>
                <span *ngSwitchCase="'match'">Match</span>
                <span *ngSwitchDefault>N/A<span *ngIf="c.detail" style="color:#9e9e9e;"> ({{ c.detail }})</span></span>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>

      <p style="margin-top:1em; color:#757575; font-size:0.85em;">
        Saved to this location's QA Review notes. [qa_log: {{ data.logId }}]
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end" style="background:#ffffff;">
      <button mat-button color="primary" [mat-dialog-close]="1">Close</button>
    </mat-dialog-actions>
  